import React from 'react';
import './ProductHub.css';
import { useNavigate } from 'react-router-dom';
import { FaHeart } from 'react-icons/fa';
import { FaHeartCircleBolt } from 'react-icons/fa6';

const products = [
  {
    title: "3-Piece Classic Fit Suit with Tailored Jacket, Vest, and Trousers",
    price: "$324.99.00",
    imageUrl: require('../../assets/productImages/product1.png'),
    link: '/product-view/*'
  },
  {
    title: "Men's Linen Shirt Pant Set",
    price: "$79.00.00",
    imageUrl: require('../../assets/productImages/product2.png'),
    link: '/product-view/*'
  },
  {
    title: "Classic Apex Oxford Suit",
    price: "$69.99.00",
    imageUrl: require('../../assets/productImages/product7.png'),
    link: '/product-view/*'
  },
  {
    title: "Double-Breasted Cashmere And Wool Blend Pont Neuf Suit",
    price: "$324.00.00",
    imageUrl: require('../../assets/productImages/product4.png'),
    link: '/products'
  },
  {
    title: "3-Piece Classic Fit Suit with Tailored Jacket, Vest, and Trousers",
    price: "$324.99.00",
    imageUrl: require('../../assets/productImages/product1.png'),
    link: '/products'
  },
  {
    title: "Men's Linen Shirt Pant Set",
    price: "$79.00.00",
    imageUrl: require('../../assets/productImages/product2.png'),
    link: '/products'
  },
  {
    title: "Classic Apex Oxford Suit",
    price: "$69.99.00",
    imageUrl: require('../../assets/productImages/product7.png'),
    link: '/products'
  },
  {
    title: "Double-Breasted Cashmere And Wool Blend Pont Neuf Suit",
    price: "$324.00.00",
    imageUrl: require('../../assets/productImages/product4.png'),
    link: '/products'
  }
];

const ProductHub = () => {
  const navigate = useNavigate();

  return (
    <section className="productHub">
      <div className="products-grid">
        {products.map((cat, idx) => (
          <div
            key={idx}
            onClick={() => navigate(cat.link)}
            className="product-card"
          >
          <span className='heart'><FaHeart/></span>
            <img
              src={cat.imageUrl}
              alt={cat.title}
              className="product-image"
              
            />
            <div className='productCard__info'> 
                <p className="product-name">{cat.title}</p>
                <p className="product-price">{cat.price}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductHub;
